// extracted by mini-css-extract-plugin
export default {"container":"p1-z","heading":"q1-z","links":"r1-z","copy":"s1-z","subCopy":"t1-z","linksLeft":"u1-z","linksCenter":"v1-z","linksRight":"w1-z","link":"x1-z","onlyLink":"y1-z"};